module.exports = __webpack_public_path__ + "img/productsec-mid.aa805cef.png";